export const roles = {
  CUSTOMER_MANAGER: 'CustomerManager',
  CUSTOMER_ADMIN: 'CustomerAdmin',
  SP_WORKER: 'SPWorker',
  SP_FREELANCER: 'SPFreelancer',
};

export const registrationRoles = {
  CUSTOMER_ADMIN: roles.CUSTOMER_ADMIN,
  SP_WORKER: roles.SP_WORKER,
  SP_FREELANCER: roles.SP_FREELANCER,
};

export const SPRoles = {
  SPAdmin: 'SPAdmin',
  SPFreelancer: 'SPFreelancer',
  SPWorker: 'SPWorker',
};

export const registrationFisrtStep = {
  COMPANY: 'Company',
  CLIENT: 'Client',
};

// Tenant role values
export const tenantRoles = {
  TENANT_ADMIN: 'TenantAdmin',
  TENANT_USER: 'TenantUser',
  TENANT_UNPRIVILEGED_USER: 'TenantUnprivilegedUser',
  BILLING_ADMIN: 'BillingAdmin',
  BILLING: 'Billing',
};

// Display names for user roles
export const userRoles = {
  TenantAdmin: 'Admin',
  TenantUser: 'User',
  TenantUnprivilegedUser: 'Unprivileged',
  BillingAdmin: 'Billing Admin',
  Billing: 'Billing',
};
